import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'

import { CellRenderer } from '@/utils/table'

const CUSTOM_MAP_BENTUK_PENINGKATAN = {
  'PONDOK PESANTREN': 'Pesantren',
  KURSUS: 'Kursus',
}

export const PtkCellRenderer = ({ row, col, onClickNpsn }) => {
  const value = row.getValue()
  const originalRowData = row?.row?.original || {}

  if (col?.id === 'npsn') {
    return (
      <div
        data-type={col?.id || ''}
        data-clickable="true"
        className="min-w-[90px] cursor-pointer"
        onClick={() => {
          onClickNpsn(originalRowData)
        }}
      >
        <Link underline={false} as="p">
          {value}
        </Link>
      </div>
    )
  }

  if (col?.id === 'nama') {
    return (
      <div data-type={col?.id || ''} className="min-w-[200px]">
        <Text>{value}</Text>
      </div>
    )
  }

  // Kolom = Alamat
  if (col?.id === 'alamatJalan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[200px]">
        <Text>{value}</Text>
      </div>
    )
  }

  // Kolom = Kelurahan
  if (col?.id === 'namaDesa') {
    return (
      <div data-type={col?.id || ''} className="min-w-[150px]">
        <Text>{value}</Text>
      </div>
    )
  }

  // Kolom = Pendidik
  if (col?.id === 'jumlahGuru') {
    return (
      <div data-type={col?.id || ''} className="min-w-[70px] text-right">
        <Text>{value}</Text>
      </div>
    )
  }

  // Kolom = Tenaga Kependidikan
  if (col?.id === 'jumlahTendik') {
    return (
      <div data-type={col?.id || ''} className="min-w-[110px] text-right">
        <Text>{value}</Text>
      </div>
    )
  }
  // Kolom = Jenjang
  if (col?.id === 'bentukPendidikanGroup') {
    return (
      <div data-type={col?.id || ''} className="min-w-[110px]">
        <Text>
          {CUSTOM_MAP_BENTUK_PENINGKATAN[value]
            ? CUSTOM_MAP_BENTUK_PENINGKATAN[value]
            : value.replace(/ SEDERAJAT/g, '/Sederajat')}
        </Text>
      </div>
    )
  }

  // Kolom = Jenis
  if (col?.id === 'jenisPendidikan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[120px] capitalize">
        <Text>{value.replace(/PENDIDIKAN/g, '').toLowerCase()}</Text>
      </div>
    )
  }

  // Kolom = Status
  if (col?.id === 'statusSatuanPendidikan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[80px]">
        <Text>{value}</Text>
      </div>
    )
  }

  return <CellRenderer getValue={row.getValue} />
}
